import { fn, hash } from '@ember/helper';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/forms';
import DirectorySelect from 'umg-ember-backend/components/ui/directory-select';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsVhostComponent extends Component {
  // Defaults
  interpreters = ['php85', 'php84', 'php83', 'php82', 'phpNone'];

  types = [
    'WP_VHOST',
    'REDIRECT',
    'WP_VHOST_PB_LARAVEL',
    'WP_VHOST_PB_NEXT',
    'CRM_VHOST',
    'CSAM_VHOST',
    'ECOM_VHOST',
    'PRODOPS_VHOST',
  ];

  // Getter and setter
  get interpreterOptions() {
    return labelValueOptions.call(this, this.interpreters, [
      'forms.vhost.options.interpreter',
    ]);
  }

  get typeOptions() {
    return labelValueOptions.call(this, this.types, [
      'forms.vhost.options.type',
    ]);
  }

  // Functions
  selectType = (option) => {
    this.args.model.type = option.value;

    if (option.value === 'WP_VHOST_PB_LARAVEL') {
      this.args.model.interpreter = 'php85';
      this.args.model.documentRoot =
        '/nfs/vhosts/cms/UMG/mlp.universal-music.de/prod/current';
      this.args.model.vhostTemplate56 =
        '#PHP-FPM-MOUNT /nfs/vhosts/cms/UMG/mlp.universal-music.de/prod';
      this.args.model.fpmTemplateAdm56 = '';
      this.args.model.redirect = '';
    } else if (option.value === 'WP_VHOST_PB_NEXT') {
      this.args.model.interpreter = 'phpNone';
      this.args.model.documentRoot = '/nfs/vhosts/cms/empty';
      this.args.model.vhostTemplate56 =
        'Header set Cache-Control "public, max-age=7200"\n#K8SPROXY 32102';
      this.args.model.fpmTemplate56 = '';
      this.args.model.fpmTemplateAdm56 = '';
      this.args.model.redirect = '';
    } else if (option.value === 'REDIRECT') {
      this.args.model.documentRoot = '';
      this.args.model.vhostTemplate56 = '';
      this.args.model.fpmTemplate56 = '';
      this.args.model.fpmTemplateAdm56 = '';
      this.args.model.redirect = '';
    }
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <InfoBox @type='warning'>
              {{t 'record_detail.forms.vhost.hint' htmlSafe=true}}
            </InfoBox>

            <fieldset.field
              @property='type'
              @type='select-value'
              @options={{this.typeOptions}}
              @onChange={{this.selectType}}
            />
            <fieldset.field
              @property='domains'
              @type='has-many'
              @insertAtEnd={{true}}
              @on={{hash openNewRecord=false}}
            />
            <fieldset.field
              @disabled={{true}}
              @property='previewMlps'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
            {{#if form.model.hasMountpoint}}
              <fieldset.field
                @property='interpreter'
                @type='select-value'
                @options={{this.interpreterOptions}}
              />
            {{/if}}
            {{#unless form.model.hasTargets}}
              <fieldset.field @property='monitoring' @type='checkbox' />
            {{/unless}}
            <fieldset.field @property='information' @type='textarea' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          {{#if form.model.hasTargets}}
            <form.fieldset @titleKey='redirect' as |fieldset|>
              <fieldset.field @property='redirect' />
              <fieldset.field @property='redirectKeepPath' @type='checkbox' />
            </form.fieldset>
          {{/if}}

          {{#if form.model.hasMountpoint}}
            <form.fieldset @titleKey='wpvHost' as |fieldset|>
              <DirectorySelect
                @onSelect={{fn (mut form.model.documentRoot)}}
                @root='/nfs/vhosts/cms'
                @selected={{form.model.documentRoot}}
                @server='docroot.universal-music-services.de'
              >
                <fieldset.field @property='documentRoot' @readonly={{true}} />
              </DirectorySelect>

              <fieldset.field @property='vhostTemplate56' @type='textarea' />
              <fieldset.field @property='fpmTemplate56' @type='textarea' />
              <fieldset.field @property='fpmTemplateAdm56' @type='textarea' />
            </form.fieldset>
          {{/if}}

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
